<template>
  <div class="qm-picture-library-detail-dialog">
    <template v-if="isShowMoreImage">
      <el-scrollbar wrapStyle="height:482px;overflow-x:hidden;">
        <div v-if="selectImages && selectImages.length" class="image-more-info">
          <div
            v-for="item in selectImages"
            :key="item.id"
            :class="{ 'qm-upload__info_img': galleryShowType === 2 }"
            class="image-more-info_item"
          >
            <img v-if="galleryShowType === 1" :src="`${item.domain}/${item.path}`" alt="" />
            <img
              v-else
              :src="
                item.coverUrl
                  ? item.coverUrl
                  : 'https://images.qmai.cn/resource/20210824211416/2021/11/30/video-default-img.png'
              "
              alt=""
            />
          </div>
        </div>
      </el-scrollbar>
    </template>
    <template v-else>
      <template v-if="imageInfo">
        <div class="image-box" v-if="galleryShowType === 1">
          <img class="image-detail" :src="imageInfo.path" />
        </div>
        <div class="qm-upload__image-box" v-else>
          <Dplayer ref="player" :options="playOptions" />
        </div>
        <div class="info-form">
          <div class="form-item">
            <div class="form-label">
              {{ galleryShowType === 1 ? ' 图片名：' : ' 文件名称：' }}
            </div>
            <div class="form-content">
              <span class="truncate">
                <el-input
                  size="small"
                  v-if="imageInfo.isShowPictureName"
                  v-model="imageInfo.partName"
                  :spellcheck="false"
                ></el-input>
                <template v-else>{{ imageInfo.name }}</template>
              </span>
              <template v-if="galleryType">
                <i class="qm-icon qm-icon-success" v-if="imageInfo.isShowPictureName" @click="saveImageInfo"></i>
                <i class="qm-icon qm-icon-edit" v-else @click="imageInfo.isShowPictureName = true"></i>
              </template>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">文件路径：</div>
            <div class="form-content">
              <span class="truncate">{{ imageInfo.path }}</span>
              <i class="qm-icon qm-icon-copy tag-read" :data-clipboard-text="`${imageInfo.path}`" @click="copyPath"></i>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">{{ galleryShowType === 1 ? ' 图片大小：' : ' 文件大小：' }}</div>
            <div class="form-content">
              <template v-if="imageInfo.size">
                <span v-if="galleryShowType === 1"> {{ imageInfo.size | imageSize() }}KB </span>
                <span v-else> {{ imageInfo.size | videoSize() }}MB </span>
              </template>
              <span v-else>暂无</span>
            </div>
          </div>
          <div class="form-item" v-if="galleryShowType === 1">
            <div class="form-label">图片比例：</div>
            <div class="form-content">
              <template v-if="imageInfo.width">
                <span> {{ imageInfo.width }}x{{ imageInfo.height }} </span>
              </template>
              <span v-else>暂无</span>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">上传时间：</div>
            <div class="form-content">{{ imageInfo.createTime }}</div>
          </div>
          <div class="form-item">
            <div class="form-label">修改时间：</div>
            <div class="form-content">{{ imageInfo.updateTime }}</div>
          </div>
          <div class="form-item" v-if="galleryType">
            <div class="form-label">备注：</div>
            <div class="form-content">
              <span class="truncate">
                <el-input
                  size="small"
                  v-if="imageInfo.isShowDescription"
                  v-model="imageInfo.description"
                  :spellcheck="false"
                ></el-input>
                <template v-else>{{ imageInfo.description }}</template>
              </span>
              <template v-if="galleryType">
                <i class="qm-icon qm-icon-success" v-if="imageInfo.isShowDescription" @click="saveImageInfo"></i>
                <i class="qm-icon qm-icon-edit" v-else @click="imageInfo.isShowDescription = true"></i>
              </template>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="no-select-text">没有选中</div>
    </template>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import { getVideoInfo, editVideoDetail } from '../api'
import Dplayer from './dplayer.vue'

export default {
  props: {
    imageInfo: {
      type: Object,
      default: () => {},
    },
    isShowMoreImage: {
      type: Boolean,
      default: false,
    },
    selectImages: {
      type: Array,
      default: () => [],
    },
    galleryType: {
      type: Number,
      default: 0,
    },
    galleryShowType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      playOptions: {
        video: {
          url: '',
          pic: '',
        },
        autoplay: false,
      },
    }
  },
  watch: {
    imageInfo: {
      handler(val) {
        if (val && this.galleryShowType === 2) {
          this.getPlayUrl()
        }
      },
      immediate: true,
    },
  },
  filters: {
    // 图片 将字节转为KB
    imageSize(size) {
      if (!size) return false
      const picSize = Number(size) / 1024
      const newPicSize = picSize && picSize.toFixed(3)
      return newPicSize > 0.001 ? newPicSize : 0.001
    },
    // 视频  将字节转为MB
    videoSize(size) {
      if (!size) return false
      const picSize = Number(size) / 1024 / 1024
      return picSize && picSize.toFixed(2)
    },
  },
  components: {
    Dplayer,
  },
  methods: {
    // 编辑保存图片信息
    saveImageInfo() {
      if (this.galleryShowType === 1) {
        this.$emit('saveImageInfo', this.imageInfo)
      } else {
        this.saveVideoInfo()
      }
    },
    // 修改视频信息 ----------------------
    saveVideoInfo() {
      const { id, coverUrl, description, partName, nameType } = this.imageInfo
      if (!partName) {
        this.$message.error('请输入音视频名称')
        return
      }
      const dealPartName = partName.replace(/[\ |\.|\?]/g, '')
      const completeName = `${dealPartName}.${nameType}`
      const data = {
        id,
        cover_url: coverUrl,
        title: completeName,
        description,
      }
      editVideoDetail(data).then(res => {
        if (res.status) {
          this.imageInfo.name = completeName
          this.$message.success('音视频信息更新成功')
          this.$emit('saveVideoInfo', this.imageInfo)
          this.imageInfo.isShowDescription = false
          this.imageInfo.isShowPictureName = false
        }
      })
    },
    // 获取播放地址 ----------------------
    getPlayUrl() {
      if (!this.imageInfo) {
        return
      }
      if (!this.imageInfo.videoId) {
        this.playOptions.video.url = this.imageInfo.path
        this.playOptions.video.pic =
          this.imageInfo.coverUrl || 'https://images.qmai.cn/resource/20210824211416/2021/11/30/video-default-img.png'
        if (this.$refs.player) {
          this.player = this.$refs.player.dp
          this.switchHandle(this.playOptions.video.url, this.playOptions.video.pic)
        }
      } else {
        getVideoInfo(this.imageInfo.videoId).then(res => {
          if (res.status) {
            this.playOptions.video.url = res.data.Mezzanine.FileURL
            this.playOptions.video.pic = this.imageInfo.thumb
            this.imageInfo.path = res.data.Mezzanine.FileURL // 视频播放地址
            if (this.$refs.player) {
              this.player = this.$refs.player.dp
              this.switchHandle(this.playOptions.video.url, this.playOptions.video.pic)
            }
          }
        })
      }
    },
    // 视频切换 ----------------------
    switchHandle(url, pic) {
      this.player.switchVideo({
        url,
        pic,
      })
    },
    copyPath() {
      const clipboard = new Clipboard('.tag-read')
      clipboard.on('success', e => {
        this.$message.success('复制成功')
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        this.$message.error('不支持复制,该浏览器不支持自动复制')
        clipboard.destroy()
      })
    },
  },
}
</script>
